import { CapabilitySectionKind } from '../../../../../api/agents-client/agent-client.type';
import { CapabilitySectionView } from '../../agent-customize/capability-section';
import { SaveStatus } from '../../shared/settings/save-status';
import { FloraSettingsSection } from '../agent-settings.type';
import { useFloraToolSettings } from '../use-flora-tool-settings';
import { SettingsSectionShell } from './settings-section-shell';

/**
 * Renders the Tools settings section: each built-in capability (automations,
 * targets, slash commands, Jira, and so on) with its on/off and per-tool
 * approval controls. Changes save automatically.
 *
 * @returns {JSX.Element} The Tools section
 */
export function SettingsToolsSection() {
  const { capabilities, draft, isLoading, error, saveState, handlers } = useFloraToolSettings();
  const tools = (capabilities?.sections ?? []).filter((section) => section.kind === CapabilitySectionKind.Capability);

  return (
    <SettingsSectionShell
      section={FloraSettingsSection.Tools}
      subtitle="Built-in tools Flora uses in every chat, and whether their actions need your approval."
      headerRight={<SaveStatus state={saveState} />}
      isLoading={isLoading}
      errorMessage={error || (!isLoading && !draft) ? 'Failed to load Flora tools' : null}
    >
      {draft &&
        tools.map((section) => (
          <CapabilitySectionView key={section.id} section={section} draft={draft} handlers={handlers} />
        ))}
    </SettingsSectionShell>
  );
}
